import React, {useEffect, useState} from "react";
import StudentsNavbar from "../../Components/Navbars/StudentsNavbar";
import {CommonInformation} from "./CommonInformation";
import {Education} from "./Education";
import {About} from "./About";
import {Diplomas} from "./Diplomas";
import {Tabs, TabsProps} from "antd";
import styled from "styled-components";

const PaddingDiv = styled.div`
  padding-top : 42.6px;
  padding-left : 6%; 
  padding-right : 6%;
`

const Styles = styled.div`
  input:hover,
  select:hover,
  textarea:hover {
    border-color: #56ADF3;
  }

  .form-check-input:checked{
    border-color: #2196F3;
    background-color: #2196F3;
  }

  div[role="tab"]{
    color: #222222;
  }

  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2196F3 !important;
  }

  .ant-tabs-ink-bar.ant-tabs-ink-bar-animated {
    background-color: #2196F3 !important;
  }

  input:invalid,
  textarea:invalid{
    border-color: #F34921;
  }

  input:focus,
  textarea:focus,
  select:focus {
    box-shadow: 0px 0px 4px 0px #0E6AED80 !important;
  }

  input:invalid:focus,
  textarea:invalid:focus {
    border-color: #F34921;
    box-shadow: 0px 0px 4px 0px rgba(243, 73, 33, 0.25) !important;
  }

  .error-alert{
    margin-top: 0;
    min-height: 1.75em;
  }

  textarea#specName{
    height: 4.5em;
    resize: none;
  }

  .ant-tabs-nav::before{
    border-bottom-color: #D1D6DC !important;
  }

  footer {
    position: sticky;
    padding: 16px 6vw 16px 0%;
    max-width: 100%;
    transition: box-shadow 200ms ease-in-out;
    
    @media only screen and (max-width: 440px) {
      width: calc(12% + 440px);
    }
  }

  footer.with-border {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  }

  footer.without-border {
    box-shadow: none;
  }
`

export const StudentInfoEdit = () => {
  const [isBottom, setIsBottom] = useState<boolean>(false)

  useEffect(() => {
    handleScroll()
    window.addEventListener("scroll", () => handleScroll());
    window.addEventListener("resize", () => handleScroll());
  },[])

  const handleScroll = () => {
    const element = document.getElementById("main");

    element && setIsBottom(element.getBoundingClientRect().bottom - window.innerHeight <= 30)
  }

  const tabItems: TabsProps['items'] = [
    {
      key : '1',
      label : 'Общая информация',
      children : <CommonInformation isBottom={isBottom} handleFooter={handleScroll}/>
    },
    {
      key : '2',
      label : 'Образование',
      children : <Education isBottom={isBottom} handleFooter={handleScroll}/>
    },
    {
      key : '3',
      label : 'Обо мне',
      children : <About isBottom={isBottom} onResize={handleScroll} handleFooter={handleScroll}/>
    },
    {
      key : '4',
      label : 'Дипломы',
      children : <Diplomas isBottom={isBottom} handleFooter={handleScroll}/>
    },
  ]

  return(
    <Styles id="main">
      <StudentsNavbar/>
      <PaddingDiv>
        <h1>Аккуант</h1>
        <Tabs
          defaultActiveKey="1"
          items={tabItems}
          destroyInactiveTabPane={true}
        />
      </PaddingDiv>
    </Styles>
  )
}